import { CopyOutlineIcon } from '@carboncopyco/icons';
import type { TypographyProps } from '@carboncopyco/ui';
import {
  ColorHex,
  TextCaption,
  TooltipBubble,
  Typography,
} from '@carboncopyco/ui';
import { useCopy } from '../../hooks';

type CodeTextProps = Pick<TypographyProps, 'label' | 'color' | 'ellipsis'>;

function CodeText({ label, color, ellipsis }: CodeTextProps) {
  return (
    <Typography
      color={color}
      label={label}
      ellipsis={ellipsis}
      tagName="span"
      fontSize="text-ds-400"
      lineHeight="leading-ds-300"
      fontWeight="font-ds-normal"
      fontFamily="font-ds-monospace"
    />
  );
}

type VariableCodeFieldProps = {
  value: string;
  showCopyButton?: boolean;
};

export const VariableCodeField = ({
  value,
  showCopyButton = false,
}: VariableCodeFieldProps) => {
  const { copyText } = useCopy();
  const color = value ? 'text-ds-primary-300' : 'text-ds-natural-200';

  return (
    <div className="flex flex-col gap-2">
      <label htmlFor="placeholder">
        <TextCaption
          label="Placeholder"
          color="text-ds-natural-600"
        />
      </label>
      <input
        className="hidden"
        type="text"
        value={value}
        id="placeholder"
        readOnly
      />
      <div className="w-full flex justify-between items-center h-ds-lg-input tracking-ds-normal px-3 py-2 bg-ds-primary-50 border-ds-natural-150 rounded-md border">
        <div className="flex truncate">
          <CodeText
            color={color}
            label="{{ "
          />
          {value && (
            <CodeText
              ellipsis
              label={value}
              color={color}
            />
          )}
          <CodeText
            color={color}
            label=" }}"
          />
        </div>

        {showCopyButton && value && (
          <TooltipBubble
            placement="top"
            title="Copy"
            offset={[8, -1]}
          >
            <div
              className="flex items-center h-full cursor-pointer ml-2"
              onClick={() =>
                copyText(
                  `{{${value}}}`,
                  'Variable placeholder was copied to your clipboard.'
                )
              }
            >
              <CopyOutlineIcon
                size={20}
                color={ColorHex.primary300}
              />
            </div>
          </TooltipBubble>
        )}
      </div>
    </div>
  );
};
